import Details from './Details.vue'

export default Details
